<template>
<!-- Footer Padrão para Todas as Telas Exceto algumas -->
<footer class="group__footer">
    <div class="group__footer__content">
        <div class="container-one">
            <div class="logo">
                <a v-bind:href="'/'">
                    <img :src="logoUrl" alt="Marca Onboard Entretenimento">
                </a>
            </div>
            <div class="social-networks">
                <div class="title">Redes Sociais</div>
                <div class="social-networks__list">
                    <a href="/" class="fa-brands fa-square-facebook"></a>
                    <a href="/" class="fa-brands fa-square-x-twitter"></a>
                    <a href="/" class="fa-brands fa-square-instagram"></a>
                </div>
            </div>
            <div class="help">
                <div class="title">Ajuda</div>
                <ul class="help__list">
                    <li><a href="/">Fale conosco</a></li>
                    <li v-if="!isLogged" ><a href="/login-options">Fazer Login</a></li>
                    <li v-if="!isLogged" ><a href="/register">Cadastrar</a></li>
                </ul>
            </div>
            <div class="politics">
                <div class="title">Políticas</div>
                <ul class="politics__list">
                    <li><a href="/">Política de Privacidade</a></li>
                    <li><a href="/">Termos e Condições</a></li>
                    <li><a href="/">Política de Cancelamento</a></li>
                </ul>
            </div>
        </div>
        <div class="container-two">
            <p>
                <b>Onboard Entretenimento | CNPJ: 42.112.589/0001-60</b> | Rua Luigi Galvani, 70, Conjunto 81/82, Cidade Moncoes, São Paulo, SP. CEP: 04575-020 |
                <b>Horário de Atendimento:</b> 8h a 18h, Segunda a Sexta Feira, exceto feriados
            </p>
        </div>
    </div>
</footer>
</template>

<script setup>
import logoUrl from '@/assets/logo.png'
import { ref, onMounted } from 'vue';

const isLogged = ref(false)

async function checkIfLogged() {
    isLogged.value = sessionStorage.getItem('user')
}

onMounted(async () => {
    checkIfLogged()
})
</script>